import React from "react";
import { Button } from "@material-ui/core";
import { auth, provider } from "../../firebase";
import { useStateValue } from "../../StateProvider";
import { actionTypes } from "../../Reducer";
import "./login.css";

const Login = () => {
  const [{}, dispatch] = useStateValue();
  const signIn = () => {
    auth
      .signInWithPopup(provider)
      .then((result) => {
        dispatch({
          type: actionTypes.SET_USER,
          user: result.user,
        });
      })
      .catch((error) => alert(error.message));
  };
  return (
    <div className="login__wrapper">
      <div className="login__logo">
        <img src="logo512.png" alt="login" />
        <h1>Popular Social</h1>
      </div>
      <Button type="submit" className="login__btn" onClick={signIn}>
        Sign In
      </Button>
    </div>
  );
};

export default Login;
